var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.6 256C256.6 208.872 294.805 170.667 341.933 170.667C389.061 170.667 427.266 208.873 427.266 256C427.266 303.129 389.06 341.333 341.933 341.333C294.804 341.333 256.6 303.128 256.6 256Z",
    fill: "#00BCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9326 426.667C85.9326 379.539 124.138 341.334 171.266 341.334L216.741 317.325L256.599 341.334V426.667C256.599 473.796 218.394 512 171.266 512C124.138 512 85.9326 473.795 85.9326 426.667Z",
    fill: "#00CF7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.599 0L210.165 80.67L256.599 170.666H340.735C387.864 170.666 426.068 132.461 426.068 85.333C426.068 38.205 387.863 0 340.735 0H256.599Z",
    fill: "#FF7361"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7344 85.333C84.7344 132.461 122.939 170.666 170.067 170.666L215.334 188.15L256.597 170.666V0H170.066C122.939 0 84.7344 38.205 84.7344 85.333Z",
    fill: "#FF4D12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9326 256C85.9326 303.129 124.138 341.333 171.266 341.333H256.599V170.666H171.266C124.138 170.666 85.9326 208.872 85.9326 256Z",
    fill: "#B659FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.46e944f425f1ca78d206a89f49da0e07.svg";
export { ForwardRef as ReactComponent };